<template>
  <path d="M7 9H33" stroke="#069EE0" stroke-width="2" stroke-linecap="round" />
  <path d="M7 20H33" stroke="#069EE0" stroke-width="2" stroke-linecap="round" />
  <path d="M7 31H33" stroke="#069EE0" stroke-width="2" stroke-linecap="round" />
</template>
